import { buildValidations, validator } from 'ember-cp-validations';
import Model, { attr } from '@ember-data/model';

const Validations = buildValidations({
  uuid: validator('presence', {
    presence: true,
    ignoreBlank: false,
  }),
});

export default class PaymentLinkModel extends Model.extend(Validations) {
  @attr() clientId;
  @attr() practiceId;
  @attr() uuid;
  @attr() totalPayableAmount;
  @attr() status;
  @attr() expiresAt;
  @attr() allocatableInvoices;
}
